import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import { Spacer } from 'components/Utility'
import addMonths from 'date-fns/addMonths'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { getStoreCurrentMonth } from 'reducks/storeCalendar/selectors'
import { handleStoreCurrentMonth } from 'reducks/storeCalendar/operations'

type Props = {
  label: string
  type: 'prev' | 'next'
}

const CloseStoreArrowButton: FC<Props> = React.memo((props) => {
  const { label, type } = props

  const dispatch = useDispatch()
  const currentMonth = useSelector((state: State) => getStoreCurrentMonth(state))

  const selectedMonth = type === 'prev' ? addMonths(currentMonth, -1) : addMonths(currentMonth, 1)

  const className = type === 'prev' ? styles.button__arrow_monthly_prev : styles.button__arrow_monthly_next

  return (
    <button className={className} onClick={() => dispatch(handleStoreCurrentMonth(selectedMonth))}>
      {type === 'prev' ? (
        <>
          <img src={`/icon/arrow_${type}.svg`} alt={label} width={20} height={20} />
          <Spacer size={8} axis={'horizontal'} />
          {label}
        </>
      ) : (
        <>
          {label}
          <Spacer size={8} axis={'horizontal'} />
          <img src={`/icon/arrow_${type}.svg`} alt={label} width={20} height={20} />
        </>
      )}
    </button>
  )
})

export default CloseStoreArrowButton
